import { render, staticRenderFns } from "./product_designs.vue?vue&type=template&id=8183ada0&scoped=true"
import script from "./product_designs.vue?vue&type=script&lang=js"
export * from "./product_designs.vue?vue&type=script&lang=js"
import style0 from "./product_designs.vue?vue&type=style&index=0&id=8183ada0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8183ada0",
  null
  
)

export default component.exports